import useOrganizationSettings from '@app/src/hooks/useOrganizationSettings'
import AiScreeningStats from '@app/src/pages/Configurations/ConfigurationsPages/AiScreening/AiScreeningStats'
import { CONFIGURATION_PAGE_IDS } from '@app/src/pages/Configurations/ConfigurationsScene'
import { palette } from '@app/src/theme/palette'
import paths from '@app/src/wf-constants/paths'
import { Button, CircularProgress, DialogContent, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { generatePath, useHistory } from 'react-router'
import { ViewTypeName } from '../../ManageRequests/ManageRequestsScene'

type ScheduleScreeningSuccessViewProps = {
  providerIds: number[]
  onClose: () => void
}

const ScheduleScreeningSuccessView: React.FC<ScheduleScreeningSuccessViewProps> = ({ providerIds = [], onClose }) => {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const { settings: organizationSettings } = useOrganizationSettings()

  return (
    <DialogContent>
      <Stack height="100%" alignItems="center">
        <Stack flexGrow={1} alignItems="center" justifyContent="center" width={588}>
          <CircularProgress sx={{ fontSize: 64, color: palette.communication.dark }} />

          <Typography variant="h6" mt={3}>
            {formatMessage({ id: 'form.scheduleProviderScreening.success.screeningInProgress' })}
          </Typography>

          <Typography color="textSecondary" mt={2}>
            {formatMessage({ id: 'form.scheduleProviderScreening.success.screeningInProgressDescription' })}
          </Typography>

          <Stack spacing={2} mt={4} width="100%" border="1px solid" borderColor="grey.300">
            <AiScreeningStats
              allowedProviderScreenings={organizationSettings?.allowedProviderScreenings ?? 0}
              totalProviderScreened={organizationSettings?.totalProviderScreened ?? 0}
              remainingProviderScreenings={organizationSettings?.remainingProviderScreenings ?? 0}
            />
          </Stack>

          <Button
            variant="text"
            sx={{ mt: 4 }}
            onClick={() => {
              onClose()
              history.push(
                generatePath(paths.configurations, {
                  configurationsPage: CONFIGURATION_PAGE_IDS.AiScreening,
                }),
              )
            }}
          >
            {formatMessage({ id: 'form.scheduleProviderScreening.success.viewLimit' })}
          </Button>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => {
              onClose()
              history.push(
                generatePath(paths.manageRequest, {
                  view: ViewTypeName.ScreenedRequests,
                }),
              )
            }}
          >
            {formatMessage({ id: 'form.scheduleProviderScreening.success.viewScreenedRequests' })}
          </Button>
        </Stack>
      </Stack>
    </DialogContent>
  )
}

export default ScheduleScreeningSuccessView
